<template>
  <v-container class="pt-7 pb-11">
    <h1 class="text-h4 mb-5">{{ 'quotes'|localize }}</h1>
    <AdminQuotes mode="all" />
  </v-container>
</template>

<script>
  import localize from '@/filters/localize';
  import AdminQuotes from '@/components/AdminQuotes.vue';

  export default {
    name: "AdminAllQuotes",
    components: { AdminQuotes },

    data() {
      return {
        
      };
    },
  }
</script>
